<template>
  <popover
    :show-delay="0"
    :hide-delay="0"
    ref="popover"
    custom-class="okr-prompts-list-popover"
    target="select-prompt"
    triggers="click blur"
    boundary="viewport"
  >
    <h2 class="text-extra-large mb-3 px-sm-4 px-3 mt-4">Try from these examples</h2>
    <ul class="text-normal-1 list-unstyled">
      <li
        class="prompt p-sm-4 p-3 pointer"
        @click="onPromptSelect(prompt)"
        v-for="prompt in prompts"
        :key="prompt"
      >
        {{ prompt }}
      </li>
    </ul>
  </popover>
</template>

<script>
import Popover from '@/components/Popover.vue'

/**
 * This gives the list of suggestions to choose from, which can be fed as a prompt to North AI.
 */
export default {
  name: 'PromptsList',
  props: ['prompts'],
  components: {
    Popover
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    onPromptSelect(prompt) {
      this.$emit('select', prompt)
      this.$refs.popover.close()
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.prompt:not(:last-child) {
  border-bottom: 1px solid $borderSecondary;
}
.prompt:hover {
  background-color: $listItemHoverBgColor;
}
</style>
<style>
.okr-prompts-list-popover {
  max-width: 512px;
  max-height: 90%;
  overflow: auto;
  margin: 16px;
}
.okr-prompts-list-popover .popover-body {
  padding: 0;
}
</style>
